import React from 'react';
import { Link } from 'react-router-dom';
import
    { Slider
    , FormGroup
    , Breadcrumbs
} from '@germix/germix-react-core';
import { withTranslation, WithTranslation } from 'react-i18next';

import Application from '../components/app/Application';
import hexToRgb from '../utils/hexToRgb';
import copyToClipboard from '../utils/copyToClipboard';

interface Props extends WithTranslation
{
}
interface State
{
    horzLength,
    vertLength,
    blurRadius,
    opacity,
    shadowColor,
    textColor,
    backgroundColor,
}

/**
 * @author Germán Martínez
 */
class RouteToolsTextShadow extends React.Component<Props,State>
{
    state =
    {
        horzLength: 0,
        vertLength: 0,
        blurRadius: 0,
        opacity: 0.5,
        shadowColor: '#000000',
        textColor: '#000000',
        backgroundColor: '#FFFFFF',
    }
    render()
    {
        const { t } = this.props;
    
        return (
<Application>
    <FormGroup>
        <Breadcrumbs>
            <Link to='/'>{t('titles.home')}</Link>
            <Link to='/tools'>{t('titles.tools')}</Link>
            <Link to='/tools/text-shadow'>{t('titles.toolsTextShadowGenerator')}</Link>
        </Breadcrumbs>
        <br/>
    </FormGroup>
    <FormGroup>
        <h1>{t('titles.toolsTextShadowGenerator')}</h1>
    </FormGroup>
    <FormGroup>
        <div className="row">
            <div className="col">
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolTextShadow.horzLengthLabel')}</label>
                        <label className="ml-auto">{this.state.horzLength}px</label>
                    </div>
                    <Slider
                        min={-200}
                        max={+200}
                        value={this.state.horzLength}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            horzLength: newValue
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolTextShadow.vertLengthLabel')}</label>
                        <label className="ml-auto">{this.state.vertLength}px</label>
                    </div>
                    <Slider
                        min={-200}
                        max={+200}
                        value={this.state.vertLength}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            vertLength: newValue
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolTextShadow.blurRadiusLabel')}</label>
                        <label className="ml-auto">{this.state.blurRadius}px</label>
                    </div>
                    <Slider
                        min={0}
                        max={+200}
                        value={this.state.blurRadius}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            blurRadius: newValue
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div className='row'>
                        <div className='col'>
                            <label>{ t('toolTextShadow.shadowColorLabel')}</label>
                            <br/>
                            <input
                                type="color"
                                value={this.state.shadowColor}
                                onChange={(e: any) =>
                                {
                                    this.setState({
                                        shadowColor: e.target.value
                                    });
                                }}
                            ></input>
                        </div>
                        <div className='col'>
                            <label>{ t('toolTextShadow.textColorLabel')}</label>
                            <br/>
                            <input
                                type="color"
                                value={this.state.textColor}
                                onChange={(e: any) =>
                                {
                                    this.setState({
                                        textColor: e.target.value
                                    });
                                }}
                            ></input>
                        </div>
                        <div className='col'>
                            <label>{ t('toolTextShadow.backgroundColorLabel')}</label>
                            <br/>
                            <input
                                type="color"
                                value={this.state.backgroundColor}
                                onChange={(e: any) =>
                                {
                                    this.setState({
                                        backgroundColor: e.target.value
                                    });
                                }}
                            ></input>
                        </div>
                    </div>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolTextShadow.opacityLabel')}</label>
                        <label className="ml-auto">{this.state.opacity}</label>
                    </div>
                    <Slider
                        min={0}
                        max={1}
                        step={0.01}
                        value={this.state.opacity}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            opacity: newValue
                        });
                    }}/>
                </FormGroup>
            </div>
            <div className="col">
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <input className="form-control" value={this.fullFormatTextShadow()} readOnly={true} />
                        <span className="mini-button ml-1" onClick={() =>
                        {
                            copyToClipboard(this.fullFormatTextShadow());
                        }}>
                            <i className="icon-clipboard"></i>
                        </span>
                    </div>
                </FormGroup>
                <div className="simple-test-text-panel" style={{
                    color: this.state.textColor,
                    background: this.state.backgroundColor,
                    textShadow: this.formatTextShadow(),
                }}>
                    Sample Text
                </div>
            </div>
        </div>
    </FormGroup>
</Application>
        );
    }

    private formatTextShadow()
    {
        const shadowRgb = hexToRgb(this.state.shadowColor);

        return ''
                + this.state.horzLength + 'px '
                + this.state.vertLength + 'px '
                + this.state.blurRadius + 'px '
                + 'rgba('
                    + shadowRgb.r+','
                    + shadowRgb.g+','
                    + shadowRgb.b+','
                    + this.state.opacity+')'
    }

    private fullFormatTextShadow()
    {
        return 'text-shadow: ' + this.formatTextShadow() + ';';
    }
}
export default withTranslation('common')(RouteToolsTextShadow);
